import { Stack, Box, Text, Tooltip, Image } from "@mantine/core";
import SvgElement from "./SvgElement";
import { IconEye } from "@tabler/icons-react";

const containerStyles = {
  position: "relative",
  cursor: "pointer",
};

const absoluteBoxStyles = {
  position: "absolute",
  height: 23,
  zIndex: 1,
  bottom: 15,
  background: "rgba(255, 255, 255, 0.7)",
  width: "80%",
  display: "flex",
  left: "10%",
  borderRadius: 100,
  gap: 5,
  justifyContent: "space-between",
  alignItems: "center",
};

const SidesComponent = ({ hasSideImage, sides }) => {
  return (
    <Stack className="poll-side-image-container" gap={6}>
      {hasSideImage ? (
        <Box className="poll-side-image-box">
          {sides.map((side, idx) => (
            <Box key={idx} className={containerStyles}>
              <div
                className="poll-side-image-container-item"
                style={{ position: "relative" }}
              >
                <Image
                  width={138}
                  height={138}
                  src={
                    side?.imagePreview ||
                    side.sideBackgroundImageObject?.large.location ||
                    "/images/image.png"
                  }
                  alt={side.text}
                  radius="md"
                  fit="cover"
                />
                <span className="side-eye-icon">
                  <IconEye color="white" />
                </span>
                <Box style={absoluteBoxStyles}>
                  <Text truncate="end" size="xs" style={{ marginLeft: "32px" }}>
                    {side.text}
                  </Text>
                </Box>
              </div>
              <Box className="side-vote-icon">
                <SvgElement name={"vote-icon"} />
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        sides.map((side, idx) => (
          <div key={idx} className="cursor-pointer poll-side-open-container">
            <div>
              <Tooltip label={side.text} multiline position="top">
                <Text
                  className="poll-side-text"
                  style={{
                    textAlign: "center",
                  }}
                  fw={600}
                >
                  {side.text}
                </Text>
              </Tooltip>
            </div>
          </div>
        ))
      )}
    </Stack>
  );
};

export default SidesComponent;
